module.exports = __webpack_public_path__ + "media/images/icon/icons8-Minimize Window-520b5bc552b593f04b2ca92357b91dea.png";